module.exports = __webpack_public_path__ + "static/media/2playerRoomsPlayed_750_1000.c4bcac0c.png";